import { Box, Text, useMatchBreakpoints } from '@pancakeswap/uikit'
import { PredictionUser } from 'state/types'
import styled from 'styled-components'
import { useTranslation } from '@pancakeswap/localization'
import { NetWinnings, NetWinningsRow, Row } from './styles'
import ResultAvatar from './ResultAvatar'

interface MobileRowProps {
  rank?: number
  user: PredictionUser
}

const StyledMobileRow = styled(Box)`
  /* background: #191b2e;
  border-radius: 16px;
  padding: 24px;

  @media screen and (max-width: 700px) {
    padding: 16px;
  } */
`

const MyRankingRow: React.FC<React.PropsWithChildren<MobileRowProps>> = ({ rank, user }) => {
  const { t } = useTranslation()
  const { isDesktop } = useMatchBreakpoints()
  if (isDesktop)
    return (
      <StyleDesktop>
        {/* {rank ? (
          <div style={{ paddingRight: '24px', paddingLeft: '0' }}>
            <Text textAlign="center" color="white" fontWeight={700}>{`#${rank}`}</Text>
          </div>
        ) : (
          <div />
        )} */}
        <div>
          <ResultAvatar user={user} />
        </div>
        <div>
          <NetWinnings
            fontWeight="700"
            fontSize="14px"
            subFontWeight="400"
            subFontSize="14px"
            amount={user.netETH}
            textPrefix={user.netETH > 0 ? '+' : ''}
            textColor={user.netETH > 0 ? 'success' : 'failure'}
            // flexDirection="column"
            alignItems="center"
          />
        </div>
        <div className="txt-bold">
          {`${parseFloat(
            user.winRate.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          ).toFixed(2)}%`}
        </div>
        <div className="txt-bold">{user.totalBetsClaimed.toLocaleString()}</div>
        <div className="txt-bold">{user.totalBets.toLocaleString()}</div>
      </StyleDesktop>
    )
  return (
    <StyledMobileRow>
      <Row mb="8px">
        {rank ? <Text fontWeight="700">{`#${rank}`}</Text> : <div />}
        <ResultAvatar user={user} />
      </Row>
      <Row mb="8px">
        <Text fontSize="14px" color="white60">
          {t('Win Rate')}
        </Text>
        <Text fontWeight="bold">
          {`${user.winRate.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%`}
        </Text>
      </Row>
      {/* <NetWinningsRow amount={user.netBNB} /> */}
      <NetWinningsRow amount={user.netETH} />
      <Row>
        <Text fontSize="14px" color="white60">
          {t('Rounds Won')}
        </Text>
        <Text fontWeight="bold">{`${user.totalBetsClaimed.toLocaleString()}/${user.totalBets.toLocaleString()}`}</Text>
      </Row>
    </StyledMobileRow>
  )
}
const StyleDesktop = styled.div`
  display: grid;
  grid-template-columns: 330px repeat(4, 1fr);
  color: #fff;
  margin-top: 12px;
  div.txt-bold {
    font-size: 14px;

    font-weight: 700;
    line-height: 140%;
  }
`
export default MyRankingRow
